import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {  PlusCircle, } from "react-feather";
import { ArrowLeft } from "lucide-react";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import {Table, Modal, Select} from "antd";
import AddRole from "../../core/modals/usermanagement/addrole";
import EditRole from "../../core/modals/usermanagement/editrole";
import { getRoles,deleteRole } from "../../service/userRoleApiServices";

const RolesPermissions = () => {
  //roles-permission
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 5, total: 0 })
  const [pageSizeModalVisible, setPageSizeModalVisible] = useState(false)
  const [tempPageSize, setTempPageSize] = useState(pagination.pageSize)
  const pageSizeOptions = [5, 10, 20, 50, 100]
  const [selectedRoleId, setSelectedRoleId] = useState(null);

  //console.log(updateRole,"UPDATE ROLE")

  // const handleUpdateRole = (record) => {
  //   setUpdateRole(record);
  // };

  //delete user
  const handleDeleteRole = async (roleId) => {
    try {
      await deleteRole(roleId);
      fetchRoles()
      const updatedRoles = roles.filter((role) => role.id !== roleId);
      setRoles(updatedRoles);
      console.log("Role deleted successfully");
    } catch (error) {
      console.error("Error deleting role:", error);
    }
  };
  const storedUserData = localStorage.getItem("user");
  const userData1 = JSON.parse(storedUserData);
  const id = userData1?.data?.uid; //

  useEffect(() => {

  
     // Fetch the data on component mount
  }, [id]);

 // const hasJobRightWithdown = userRightssub.some(right => right.right === 'Shifts' && right.fdownload=== 1); 
 const fetchRoles = async () => {
  try {
    setLoading(true)
    const value = await getRoles(); // Assuming getRoles is an async function
    setRoles(value); // Set roles once fetched
    setLoading(false)
  } catch (error) {
    setLoading(false)
    console.error("Error fetching roles:", error);
  }
};
useEffect(() => {
  
  fetchRoles(); // Call the fetchRoles function inside useEffect
}, []); 


  //roles-permission
  //const route = all_routes;


  const columns = [
    {
      title: "Role Name",
      dataIndex: "roleName",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Modules",
      dataIndex: "modules",
      render: (modules) =>
        modules
          .map((module) => module.moduleId?.label || "N/A") // Safely access moduleId.label with a fallback value
          .join(", "), // Combine them into a comma-separated string
      sorter: (a, b) => a.modules.length - b.modules.length, // Sort by the number of modules
    },

    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
          <td className="action-table-data">
              <Link
                  className="me-2 p-2"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit-units"
                  onClick={() => setSelectedRoleId(record._id)}
              >
                  <i data-feather="edit" className="feather-edit"></i>
              </Link>
              <Link className="confirm-text p-2" to="#">
                  <i
                      data-feather="trash-2"
                      className="feather-trash-2"
                      onClick={() => showConfirmationAlert(record._id)}
                  ></i>
              </Link>                      
          </td>
      ),
  }
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (recordID) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
        handleDeleteRole(recordID);
      } else {
        MySwal.close();
      }
    });
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination)
  }

  const handlePageSizeChange = () => {
    const newPagination = { ...pagination, pageSize: tempPageSize, current: 1 }
    setPagination(newPagination)
    setPageSizeModalVisible(false)
  }

  return (
    <div>
      <div className="page-wrapper-lt">
        <div className="content">
          <div className="page-header">
          <div className="add-item d-flex">
                     <div className="header-leave-container ">
                       <div>
                         <ArrowLeft size={32} />
                       </div>
       
                       <div className="page-title">
                    <h4>Roles &amp; Permission</h4>
                <h6>Manage your roles</h6>
                       </div>
                     </div>
                     <div className="page-btn">

<a
  to="#"
  className="btn btn-added"
  data-bs-toggle="modal"
  data-bs-target="#add-units"
>
  <PlusCircle className="me-2" />
  Add New
</a>


</div>
            </div>

    
          </div>
          {/* /product list */}
          <div className="card table-list-card-grid">
            <div className="card-body">
              <div className="table-top">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                  />

                </div>

              </div>

              <div className="table-responsive">
                <Table columns={columns} dataSource={roles} loading={loading}   pagination={{
                  current: pagination.current,
                  total: roles.length,
                  pageSizeOptions: ["5", "10", "20", "50"],
                  showSizeChanger: true,
                  showQuickJumper: true,
                  showTotal: (total) => `Total ${total} items`
                }}
                onChange={handleTableChange}
                // footer={() => (
                //   <div style={{ display: "flex", justifyContent: "flex-end" }}>
                //     <button className="btn btn-primary btn-sm" onClick={() => setPageSizeModalVisible(true)}>
                //       Change Page Size
                //     </button>
                //   </div>
                // )}
                />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <AddRole handlereload={fetchRoles} />
      <EditRole RoleId={selectedRoleId} handlereload={fetchRoles} />

             <Modal
        title="Change Page Size"
        open={pageSizeModalVisible}
        onOk={handlePageSizeChange}
        onCancel={() => setPageSizeModalVisible(false)}
        footer={[
          <button key="cancel" className="btn btn-cancel" onClick={() => setPageSizeModalVisible(false)}>
            Cancel
          </button>,
          <button key="submit" className="btn btn-submit" onClick={handlePageSizeChange}>
            Apply
          </button>,
        ]}
      >
        <div className="form-group">
          <label>Items per page:</label>
          <Select style={{ width: "100%" }} value={tempPageSize} onChange={(value) => setTempPageSize(value)}>
            {pageSizeOptions.map((size) => (
              <Select.Option key={size} value={size}>
                {size}
              </Select.Option>
            ))}
          </Select>
        </div>
      </Modal>
    </div>
  );
};

export default RolesPermissions;
